import { Link } from 'react-router-dom';
import './ServicesOverview.css';

const ServicesOverview = () => {
  const services = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="4" y="8" width="32" height="24" rx="4" fill="#28479e" opacity="0.1" stroke="#28479e" strokeWidth="2"/>
          <path d="M12 20H28M12 16H20M12 24H16" stroke="#28479e" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Inventory Management",
      description: <>Real-time stock tracking and visibility</>,
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M8 20L20 8L32 20V32H24V24H16V32H8V20Z" fill="#28479e" opacity="0.1" stroke="#28479e" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M20 8V20" stroke="#28479e" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: "Order Fulfilment",
      description: <>Fast, accurate pick, pack, dispatch</>,
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="6" y="14" width="24" height="16" rx="3" fill="#28479e" opacity="0.1" stroke="#28479e" strokeWidth="2"/>
          <path d="M18 14V10C18 8.89543 18.8954 8 20 8C21.1046 8 22 8.89543 22 10V14" stroke="#28479e" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="14" cy="22" r="2" fill="#28479e"/>
          <circle cx="26" cy="22" r="2" fill="#28479e"/>
          <path d="M6 18H34" stroke="#28479e" strokeWidth="2"/>
        </svg>
      ),
      title: "Freight Handling",
      description: <>Reliable inbound freight coordination nationwide</>,
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="14" fill="#28479e" opacity="0.1" stroke="#28479e" strokeWidth="2"/>
          <path d="M12 20C12 15.5817 15.5817 12 20 12C22.2091 12 24.2091 13.2091 25.4645 15" stroke="#28479e" strokeWidth="2" strokeLinecap="round"/>
          <path d="M28 20C28 24.4183 24.4183 28 20 28C17.7909 28 15.7909 26.7909 14.5355 25" stroke="#28479e" strokeWidth="2" strokeLinecap="round"/>
          <path d="M16 16L14 20L16 24" stroke="#28479e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M24 24L26 20L24 16" stroke="#28479e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Returns Processing",
      description: (
        <>
          Streamlined returns — see{' '}
          <Link to="/blog/how-to-manage-ecommerce-returns">how to manage ecommerce returns</Link>
        </>
      ),
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="4" y="6" width="32" height="28" rx="3" fill="#28479e" opacity="0.1" stroke="#28479e" strokeWidth="2"/>
          <rect x="8" y="12" width="8" height="6" rx="1" fill="#28479e" opacity="0.2"/>
          <rect x="20" y="12" width="8" height="6" rx="1" fill="#28479e" opacity="0.2"/>
          <rect x="8" y="22" width="8" height="6" rx="1" fill="#28479e" opacity="0.2"/>
          <rect x="20" y="22" width="8" height="6" rx="1" fill="#28479e" opacity="0.2"/>
        </svg>
      ),
      title: "Warehouse Optimisation",
      description: <>Maximising storage, efficiency and accuracy</>,
    }
  ];

  return (
    <section className="services-overview-section">
      <div className="services-overview-container">
        <h2 className="services-overview-heading">Our End-to-End UK Fulfilment Services</h2>
        <div className="services-overview-grid">
          {services.map((service, index) => (
            <div key={index} className="services-overview-card">
              <div className="services-overview-icon">{service.icon}</div>
              <h3 className="services-overview-title">{service.title}</h3>
              <p className="services-overview-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
